.button {
  border: none;
  outline: none;
  background-color: var(--buttonBackgroundColor);
  color: var(--buttonColor);
  opacity: var(--buttonOpacity);
  cursor: pointer;
  border-radius: 20px;
  transition: 0.3s;
  padding: 13px 22px;
  font:
    normal normal normal 1.125rem/1.5rem Roboto,
    sans-serif;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  display: inline-flex;
  flex-wrap: nowrap;
  text-wrap: nowrap;
  align-items: center;
}

.button i {
  display: block;
  font-size: 1.5rem;
  height: 1.5rem !important;
}

.buttonLink {
  text-decoration: none;
}

.button:disabled {
  cursor: not-allowed;
  --buttonBackgroundColor: var(--primary-60);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 0.5;
}

.primary {
  --buttonBackgroundColor: var(--primary-100);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}

.secondary {
  --buttonBackgroundColor: var(--secondary-100);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}

.secondaryInverse {
  --buttonBackgroundColor: var(--color-ffffff);
  --buttonColor: var(--secondary-100);
  --buttonOpacity: 1;
}

.info {
  --buttonBackgroundColor: var(--primary-60);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}

.success {
  --buttonBackgroundColor: var(--secondary-100);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}

.error {
  --buttonBackgroundColor: var(--color-c2436f);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}

.warning {
  --buttonBackgroundColor: var(--warning-100);
  --buttonColor: var(--color-ffffff);
  --buttonOpacity: 1;
}
